// Pure predicates for inline body-image upload state. Kept free of TipTap/DOM so
// they unit-test cleanly; the imperative wiring lives in useBodyImageUploads.

// A blob: src is an optimistic local preview whose S3 upload is still in flight.
export function isInFlight(src: string): boolean {
  return src.startsWith('blob:');
}

// Sources that arrive non-permanent and must be fetched + re-uploaded to our own
// storage: Google Docs hotlinks (googleusercontent) and inline data: URIs (Word).
// Our S3 URLs and blob: previews never match, so a scan using this can't loop or
// re-upload images that are already stored.
export function needsRemoteUpload(src: string): boolean {
  return /googleusercontent\.com/i.test(src) || /^data:image\//i.test(src);
}

// True while any inline image is still an optimistic blob: preview. PostEditor
// blocks Save on this so a dead blob: URL is never persisted — mirrors the
// featured-image guard.
export function bodyHasPendingUpload(html: string): boolean {
  return html.includes('blob:');
}
